module.exports = __webpack_public_path__ + "img/w3_button_check_dark.38343c27.png";